import { createFileRoute } from '@tanstack/react-router';

import { UserManagement } from '@/features/user-management/UserManagement';

export const Route = createFileRoute('/_authenticated/user-management/')({
  component: UserManagement,
});
